
export const Pages = [
        {
                path: `/`,
                name:`الرئيسية`,
                name_en:`Home`
        },
        {
                path: `about`,
                name:`من نحن`,
                name_en:`About Us`
        },
        {
                path: `products`,
                name:`منتجاتنا`,
                name_en:`Products`
        },
        {
                path: `events`,
                name:`الفعاليات`,
                name_en:`Events`
        },
        // {
        //         path: `blogs`,
        //         name:`المقالات`,
        //         name_en:`Blogs`
        // },
        {
                path: `contact`,
                name:`تواصل معنا`,
                name_en:`Contact Us`
        },
]